import clsx from 'clsx';
import React from 'react';
import Link from 'next/link';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const ArticleDisplayAd = _ref => {
  let {
    hasLabel = false,
    isSidebar = false
  } = _ref;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [hasLabel ? /*#__PURE__*/_jsx("small", {
      className: styles.label,
      children: "Advertisement"
    }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsx("div", {
      className: clsx(styles.container, isSidebar ? styles['container--sidebar'] : ''),
      children: /*#__PURE__*/_jsx(Link, {
        href: "/signup",
        children: /*#__PURE__*/_jsx("img", {
          className: styles.img,
          src: "/img/pages/templates/promotion.webp",
          alt: "Sign up for free widgets promotion",
          loading: "lazy"
        })
      })
    })]
  });
};

export default ArticleDisplayAd;